/**
 * 聊天壳（S11 PC-00 做法 A）：哪一页是“聊天页”由路由元数据说了算（路由的 handle 写 CHAT_SHELL_HANDLE），不按路径前缀猜；
 * 软键盘弹没弹起由聊天页自己量（features/communicator/useChatViewport），在这里告诉外壳。
 * 外壳（app/RootLayout）据此给 .ps-shell 加 ps-shell--chat 和 data-keyboard="open"，layout.css 在键盘期间收起底栏、底栏高度按 0 算。
 * 这里只放两样：路由标记、一个“键盘开着吗”的小开关；不放任何样式。
 */
import { useSyncExternalStore } from "react";

/** 写在路由对象的 handle 上：{ path: "communicator", element: …, handle: CHAT_SHELL_HANDLE } */
export const CHAT_SHELL_HANDLE = { shell: "chat" } as const;

export function isChatShellHandle(handle: unknown): boolean {
  return typeof handle === "object" && handle !== null && "shell" in handle && handle.shell === CHAT_SHELL_HANDLE.shell;
}

let keyboardOpen = false;
const listeners = new Set<() => void>();

/** 聊天页量到软键盘弹起 / 收起时调用；离开聊天页时要调 false */
export function setChatKeyboardOpen(open: boolean): void {
  if (keyboardOpen === open) return;
  keyboardOpen = open;
  for (const listener of listeners) listener();
}

export function useChatKeyboardOpen(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => void listeners.delete(listener);
    },
    () => keyboardOpen,
    () => false,
  );
}
